import { AppHeader } from "@/components/layout";
import { PostCardSkeleton } from "@/components/social";
import { Avatar, Skeleton } from "@/components/ui";

export function ProfilePageSkeleton() {
  return (
    <>
      <AppHeader />
      <main className="mx-auto max-w-3xl p-6">
        <Skeleton className="aspect-[16/5] w-full rounded-lg" />
        <div className="relative -mt-12 flex items-end justify-between px-2">
          <Avatar size="2xl" className="ring-4 ring-bg" />
          <Skeleton className="mb-2 h-7 w-28" />
        </div>
        <div className="mt-3 px-2">
          <Skeleton className="h-8 w-40" />
          <Skeleton className="mt-2 h-5 w-28" />
          <Skeleton className="mt-3 h-5 w-96 max-w-full" />
          <div className="mt-3 flex gap-2"><Skeleton className="h-6 w-24" /><Skeleton className="h-6 w-20" /></div>
          <Skeleton className="mt-4 h-5 w-80 max-w-full" />
        </div>
        <div className="mt-6 flex gap-6 border-b border-border px-2 pb-3">
          <Skeleton className="h-4 w-12" /><Skeleton className="h-4 w-16" /><Skeleton className="h-4 w-12" />
        </div>
        <div className="mt-4 max-w-[600px] space-y-4 px-2">
          <PostCardSkeleton variant="media" />
          <PostCardSkeleton />
          <PostCardSkeleton variant="media" />
        </div>
      </main>
    </>
  );
}
